module.exports = __webpack_public_path__ + "static/media/goto-icon.3b0fc28b.png";